import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Copy, Clipboard, Trash2, ArrowUp, ArrowDown } from 'lucide-react';

export default function ContextMenu({ 
  isOpen, 
  position, 
  onClose, 
  onCopy, 
  onDuplicate, 
  onDelete, 
  onMoveUp, 
  onMoveDown,
  canMoveUp,
  canMoveDown 
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const menuItems = [
    { 
      icon: Copy, 
      label: 'Копировать', 
      onClick: onCopy, 
      enabled: true 
    },
    { 
      icon: Clipboard, 
      label: 'Дублировать', 
      onClick: onDuplicate, 
      enabled: true 
    },
    { 
      icon: ArrowUp, 
      label: 'Переместить вверх', 
      onClick: onMoveUp, 
      enabled: canMoveUp 
    },
    { 
      icon: ArrowDown, 
      label: 'Переместить вниз', 
      onClick: onMoveDown, 
      enabled: canMoveDown 
    },
    { 
      icon: Trash2, 
      label: 'Удалить', 
      onClick: onDelete, 
      enabled: true,
      danger: true 
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          ref={menuRef}
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.15 }}
          className="fixed z-[9999] bg-white border border-gray-200 rounded-lg shadow-xl py-2 min-w-[200px]"
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`
          }}
        >
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={index}
                onClick={() => {
                  if (item.enabled) {
                    item.onClick();
                    onClose();
                  }
                }}
                disabled={!item.enabled}
                className={`w-full flex items-center gap-3 px-4 py-2 text-sm transition-colors ${
                  item.enabled
                    ? item.danger
                      ? 'text-red-600 hover:bg-red-50 cursor-pointer'
                      : 'text-gray-700 hover:bg-gray-100 cursor-pointer'
                    : 'text-gray-400 cursor-not-allowed'
                }`}
              >
                <Icon size={16} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
